<div
  class="w-100 d-flex flex-column"
  (mouseenter)="focused = true"
  (mouseleave)="focused = false"
>
  <div class="d-flex flex-grow-1 limit">
    <div
      *ngIf="loading"
      class="loading d-flex justify-content-center align-items-center"
    >
      <app-progress-spinner [diameter]="32"></app-progress-spinner>
    </div>
    <app-signature-popover
      *ngIf="!loading && showSignaturePopover && status !== undefined"
      class="signature-popover"
      [status]="status"
      [signerName]="signerName"
      [signerCPF]="signerCPF"
      [signerCNPJ]="signerCNPJ"
    ></app-signature-popover>
    <div class="d-flex w-100 h-100" *ngIf="!!fileContents">
      <pdf-viewer
        class="flex-grow-1"
        *ngIf="fileType === 'application/pdf'; else image"
        [src]="fileContents"
        [render-text]="true"
        [original-size]="false"
        [zoom-scale]="'page-fit'"
        [show-all]="true"
        [page]="1"
        [zoom]="zoom"
        [rotation]="rotation"
        (after-load-complete)="loading = false"
        (error)="errorOnLoad($event)"
      ></pdf-viewer>
      <ng-template #image>
        <app-image-preview
          #image
          [fileSrc]="fileContents?.url"
          [fileData]="fileContents?.data"
          [zoom]="zoom"
          [rotation]="rotation"
          (loaded)="loading = false"
        ></app-image-preview>
      </ng-template>
      <div class="error-message" *ngIf="!!errorMessage">{{ errorMessage }}</div>
    </div>
  </div>

  <div
    class="action-buttons my-3"
    [ngClass]="{ 'action-buttons--focused': focused }"
  >
    <!-- <button [@save] *ngIf="rotated" (click)="save()" class="p-2 action-button action-button-save">Salvar</button> -->
    <div
      class="action-button-border action-count"
      *ngIf="!!fileControl?.length"
    >
      Imagem {{ fileControl.current }}/{{ fileControl.length }}
    </div>
    <button
      type="button"
      class="p-2 action-button actions-button-correction"
      appTooltip="Ler QR Code"
      appTooltipPosition="above"
      (click)="scanQrCode()"
      *ngIf="showQrCodeButton"
      [disabled]="qrCodeDialogIsOpen"
    >
      <app-icon>qr_code_scanner</app-icon>
    </button>
    <button
      type="button"
      class="p-2 action-button actions-button-correction"
      appTooltip="Baixar imagem"
      appTooltipPosition="above"
      (click)="download()"
    >
      <app-icon>file_download</app-icon>
    </button>
    <button
      type="button"
      class="p-2 action-button actions-button-correction"
      color="accent"
      appTooltip="Apagar imagem"
      appTooltipPosition="above"
      *ngIf="showDelete"
      (click)="delete.emit(fileControl.current - 1)"
    >
      <app-icon>delete</app-icon>
    </button>
    <button
      type="button"
      class="p-2 action-button actions-button-correction"
      appTooltip="Girar imagem"
      appTooltipPosition="above"
      (click)="rotate()"
    >
      <app-icon>refresh</app-icon>
    </button>
    <button
      type="button"
      class="p-2 action-button actions-button-correction"
      appTooltip="Reduzir zoom"
      appTooltipPosition="above"
      (click)="zoomOut()"
    >
      <app-icon>remove</app-icon>
    </button>
    <button
      type="button"
      class="p-2 action-button actions-button-correction"
      appTooltip="Aumentar zoom"
      appTooltipPosition="above"
      (click)="zoomIn()"
    >
      <app-icon>add</app-icon>
    </button>
    <button
      type="button"
      class="p-2 action-button actions-button-correction last"
      appTooltip="Resetar zoom"
      appTooltipPosition="above"
      (click)="defaultZoom()"
    >
      <app-icon>crop_free</app-icon>
    </button>
  </div>
</div>
